import {AthleteNextGameModuleController} from "../athlete-next-game.module.controller";
import {ACTION_TYPES, COMPONENT_STATES} from "../../../../../core/consts";
import {FullAthletesRequestParams} from "../../../../../domain/full-athlete/full-athletes.request-params";
import {FullAthleteDomainService} from "../../../../../domain/full-athlete/services/full-athlete.domain-service";
import {AthleteNextGameModuleState} from "../models/athlete-next-game.module.state";
import {FullAthleteDataSource} from "../../../../../domain/full-athlete/full-athlete.data-source";
import {DeltaHandler} from "../../../../../infrastructure/handlers/delta-handler";

export class AthleteNextGameModuleFetchHandler extends DeltaHandler {
  controller: AthleteNextGameModuleController;
  state :AthleteNextGameModuleState;

  static injectables = [FullAthleteDomainService];

  onLoaded() {
    super.onLoaded();

    this.action();
  }

  get requestParams(): FullAthletesRequestParams {
    const topBookmaker = this.state.appState.topBookmakerId;
    const athleteIds = [this.controller.props.athleteId];
    const requestParams: FullAthletesRequestParams = new FullAthletesRequestParams(athleteIds, null, 'nextGame', topBookmaker);

    return requestParams;
  }

  async action() {
    const dataSource: FullAthleteDataSource = await this.fetch();
    await this.controller.action(ACTION_TYPES.populateData, {dataSource});

    this.store.setComponentState(COMPONENT_STATES.loaded);

    return dataSource;
  }

  async onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);

    if (prevProps?.athleteId !== nextProps?.athleteId) {
      this.store.setComponentState(COMPONENT_STATES.loading);

      await this.action();
    }
  }
}
